import * as React from "react";
import { Viewport, ViewLarge, ViewMedium, ViewSmall } from "bernie-view";

import GridLayout from "./Layouts/GridLayout/GridLayout";
import ListLayout from "./Layouts/ListLayout/ListLayout";
import ExpandoLayout from "./Layouts/ExpandoLayout/ExpandoLayout";

import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelsFlexModuleResult } from "typings/microserviceModels/hotels-flex-module";

const ImageTop = (props: { context: ExtendedContextStore; model: HotelsFlexModuleResult }) => {
  const { context, model } = props;

  return (
    <Viewport>
      <ViewLarge>
        <GridLayout context={context} model={model} />
      </ViewLarge>

      <ViewMedium>
        <ListLayout context={context} model={model} />
      </ViewMedium>

      <ViewSmall>
        <ExpandoLayout context={context} model={model} />
      </ViewSmall>
    </Viewport>
  );
};

export default ImageTop;
